import { lazy } from 'react';

import { chatsV2Translations as enChats } from '@/lang/en/chatsV2';
import { chatsV2Translations as esChats } from '@/lang/es/chatsV2';
import { chatsV2Translations as ptChats } from '@/lang/pt/chatsV2';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

const ChatsV2Page = lazy(() =>
  import('./ChatsV2Page').then((m) => ({ default: m.ChatsV2Page })),
);

/** Live conversations inbox (list, thread, context panel, socket updates). */
export const conversationsModule: FeatureModule = {
  id: 'conversations',
  routes: [{ path: 'conversations/*', to: '/app/conversations', Component: ChatsV2Page }],
  nav: [
    {
      sectionId: 'main',
      order: 30,
      to: '/app/conversations',
      label: label('global', 'sidebar_chats_label'),
    },
  ],
  i18n: namespaceBundle('chatsV2', { es: esChats, en: enChats, pt: ptChats }),
};
